module.exports = __webpack_public_path__ + "img/gradient-arabic.3322bb9a.svg";